exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1BFjVVwk3o8a9Y{margin:12px 40px 8px 56px;min-height:32px;position:relative;z-index:1}._33fqcaoh7LQ07u{left:-36px;position:absolute;top:8px}._2j8PtfvgmakqEh{margin:4px 0 0;padding:8px 0 0}._2AnV90mWRiGAIY{font-size:20px;font-weight:600;line-height:24px;margin:0;min-height:24px;overflow-wrap:break-word}._1jOfioEpcUk4U7{color:#5e6c84;cursor:default;display:inline-block;margin:4px 8px 4px 2px}", ""]);

// exports
exports.locals = {
	"header": "_1BFjVVwk3o8a9Y",
	"cardIcon": "_33fqcaoh7LQ07u",
	"dialogTitle": "_2j8PtfvgmakqEh",
	"cardName": "_2AnV90mWRiGAIY",
	"cardLocation": "_1jOfioEpcUk4U7"
};